import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import styles from './HATVBCRInfo.module.scss';
import { useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import EmptyTable from '../../common/EmptyTable/EmptyTable';

interface TableProps<T> {
  tableData: any;
  isLoading: boolean;
}

const HATVBCRInfo = <T,>({ tableData, isLoading }: TableProps<T>) => {
  const { t } = useTranslation();

  const [tableDataList, setTableDataList] = useState<any[]>(tableData);

  useEffect(() => {
    setTableDataList(tableData);
  }, [tableData]);

  const userDetails = useAppSelector((state: any) => state.userDetails.user);
  const [affiliateCode] = useState(userDetails?.affiliateCode || 0);
  const [aboNumber] = useState(userDetails?.aboNumber || 0);
  const [userAffiliateCode] = useState(userDetails?.userAffiliateCode || 0);
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);

  return isLoading ? (
    <div className={styles.empty_state_document}>
      <div className={`table_no_data ${styles.empty_state_msg}`}>{t('loading')}</div>
    </div>
  ) : isEmpty(tableDataList) ? (
    <EmptyTable message={t('no_bcr')} />
  ) : (
    <section
      className={`table_container ${styles.table_container}`}
      data-testid="BCR_table_section_testID"
    >
      <div className={`${styles.table_wrapper}`}>
        <table className={styles.table}>
          <thead className={styles.tbl_header_wrapper}>
            <tr className={`tbl_header ${styles.tbl_header}`}>
              <th
                className={`header_cell_nohover ${styles.header_cell}`}
                data-testid="BCR_table_column_header_testID"
              >
                {t('case_number')}
              </th>

              <th className={`header_cell_nohover ${styles.header_cell}`}>{t('bcr_admin')}</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(tableDataList) &&
              tableDataList.map((bcr: any, index: number) => (
                <tr
                  key={`${index}${bcr.caseNumber}`}
                  className={`tbl_data_row ${styles.tbl_data_row}`}
                  data-testid="BCR_table_row_testID"
                  style={{
                    backgroundColor: currentTheme === 'light' ? '' : '#282828',
                  }}
                >
                  <td className={`data_cell ${styles.data_cell}`}>
                    <span className={styles.type_name}>{bcr.caseNumber ?? '-'}</span>
                  </td>
                  <td className={`data_cell ${styles.data_cell}`}>
                    <span className={styles.type_name}>{bcr.bcrAdminName ?? '-'}</span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default HATVBCRInfo;
